export default {
  title: "Report Subscriptions",
  titleSingular: "Report subscription",
  subtitle: "Schedule recurring time-entry reports to Slack.",

  create: "New subscription",
  edit: "Edit",
  delete: "Delete",
  runNow: "Run now",
  enable: "Enable",
  disable: "Disable",
  save: "Save",
  cancel: "Cancel",

  name: "Name",
  schedule: "Schedule",
  destination: "Destination",
  groupedBy: "Grouped by",
  period: "Period",
  status: "Status",
  lastRun: "Last run",
  lastSuccess: "Last delivered",
  never: "Never",
  failures: "Consecutive failures",

  nameLabel: "Name",
  namePlaceholder: "e.g. Weekly client hours",
  groupByLabel: "Group by",
  groupBySecondaryLabel: "Then group by",
  groupBySecondaryHelp: "Optional second grouping level.",
  filtersLabel: "Filters",
  filtersHelp: "Leave a filter empty to include everything.",
  clientsLabel: "Clients",
  projectsLabel: "Projects",
  servicesLabel: "Services",
  membersLabel: "Members",
  periodTypeLabel: "Period type",
  periodTypeHelp:
    "Calendar covers a named range; rolling covers the last N days, weeks, or months.",
  calendarPeriodLabel: "Calendar period",
  windowUnitLabel: "Window unit",
  windowLengthLabel: "Window length",
  windowLengthHelp:
    "How many of the unit above to include, e.g. the last 4 weeks.",
  frequencyLabel: "Frequency",
  dayOfWeekLabel: "Day of week",
  timeOfDayLabel: "Time of day",
  timezoneNote: "Sends use your organization's timezone ({{timezone}}).",
  timezoneSettingsLink: "Change it in organization settings.",
  channelLabel: "Slack channel",
  channelIdLabel: "Channel ID",
  channelNameLabel: "Channel name",
  destinationHelp: "Reports post to this Slack channel.",

  dimension: {
    client: "Client",
    project: "Project",
    member: "Member",
    service: "Service",
  },
  periodType: {
    calendar: "Calendar",
    rolling: "Rolling window",
  },
  calendarPeriod: {
    this_week: "This week",
    month_to_date: "Month to date",
    last_week: "Last week",
    last_month: "Last month",
  },
  rollingUnit: {
    days: "Days",
    weeks: "Weeks",
    months: "Months",
  },
  frequency: {
    daily: "Daily",
    weekly: "Weekly",
  },

  activeBadge: "Active",
  disabledBadge: "Disabled",
  pausedBadge: "Paused",
  pausedReason: {
    scope_lost: "Paused — you no longer have access to the data it reports on.",
    owner_inactive:
      "Paused — the owner is no longer active in this organization.",
    too_many_failures: "Paused — delivery failed several times in a row.",
  },

  reconnectTitle: "Reconnect Slack to manage reports",
  reconnectMessage:
    "Invup needs to reconnect to your Slack workspace before report subscriptions can be delivered.",
  reconnectCta: "Reconnect Slack",

  emptyTitle: "No report subscriptions yet",
  emptyMessage:
    "Create a subscription to get scheduled time-entry reports delivered to Slack.",

  deleteSuccess: "Report subscriptions deleted",
  runNowSuccess: "Report queued — it will be delivered shortly.",
  enabledSuccess: "Report subscription enabled",
  disabledSuccess: "Report subscription disabled",

  addTitle: "New report subscription",
  editTitle: "Edit report subscription",

  sectionWhat: "What to report",
  sectionWhen: "When to send",
  sectionWhere: "Where to send",

  groupBySecondaryNone: "None",
  selectPlaceholder: "Select…",

  channelIdPlaceholder: "e.g. C0123ABCD",
  channelNamePlaceholder: "e.g. #finance",
  channelIdHelp:
    "In Slack, open the channel → About → copy the Channel ID. Invup must be a member of the channel.",

  dayOfWeek: {
    "1": "Monday",
    "2": "Tuesday",
    "3": "Wednesday",
    "4": "Thursday",
    "5": "Friday",
    "6": "Saturday",
    "7": "Sunday",
  },

  scheduleDaily: "Daily at {{time}}",
  scheduleWeekly: "{{day}} at {{time}}",
  rollingSummary: "Last {{count}} {{unit}}",

  enabledFilterLabel: "Enabled",

  confirmDeleteTitle: "Delete subscription?",
  confirmDeleteTitle_plural: "Delete subscriptions?",
  confirmDeleteMessage:
    "This permanently deletes the subscription. This can't be undone.",
  confirmDeleteMessage_plural:
    "This permanently deletes {{count}} subscriptions. This can't be undone.",
  deleteError: "Couldn't delete the subscriptions.",

  connectTitle: "Connect Slack",
  connectMessage:
    "Connect your Slack workspace to create and deliver report subscriptions.",
  connectCta: "Connect Slack",
  reconnectMissingScopes: "Missing permissions: {{scopes}}",

  secondaryMustDiffer: "Secondary grouping must differ from the primary.",
  rollingCountRange: "Enter a number from 1 to {{max}}.",
  nameMaxLength: "Name must be 255 characters or fewer.",
};
